import { render, staticRenderFns } from "./VehicleBooking.vue?vue&type=template&id=395bc8a4&scoped=true"
import script from "./VehicleBooking.vue?vue&type=script&lang=js"
export * from "./VehicleBooking.vue?vue&type=script&lang=js"
import style0 from "./VehicleBooking.vue?vue&type=style&index=0&id=395bc8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395bc8a4",
  null
  
)

export default component.exports